export default () => ({
    facets: [
        {},
        {}
    ]
});